import * as dayjs from 'dayjs';
import { bookingsMixin } from './BookingsMixin';

export const tasksMixin = {
    mixins: [bookingsMixin],
    computed: {
        taskType: function() {
            switch (String(this.task.type)) {
                case 'check-in':
                    return 'Check in';
                case 'check-out':
                    return 'Check out';
                case 'guest-form':
                    return 'Front desk form';
                case 'omni-channel-form':
                    return 'Guest form';
                case 'email':
                    return 'Email guest';
                case 'sms':
                    return 'SMS guest';
                case 'upsell':
                    return 'Upsell';
                case 'whatsapp':
                    return 'WhatsApp';
                case 'webhook':
                    return 'Webhook';
                case 'todo':
                default:
                    return 'To do';
            }
        },
        isFormTask: function() {
            return this.task.type === 'guest-form' || this.task.type === 'omni-channel-form';
        },
        taskIcon: function () {
            return this.taskIconForTask(this.task);
        },
        taskStateIcon: function () {
            return this.stateIconForTask(this.task);
        },
        tooltipTextForTaskState: function () {
            return this.tooltipTextForStateForTask(this.task);
        },
        taskName: function() {
            return this.taskNameForTask(this.task);
        },
        isTaskScheduled: function() {
            return this.isScheduledForTask(this.task);
        },
        isTaskPaused: function() {
            return this.isPausedForTask(this.task);
        },
        isTaskCancelled: function() {
            return this.isCancelledForTask(this.task);
        },
        isTaskComplete: function() {
            return this.isCompletedForTask(this.task);
        },
        isTaskError: function() {
            return this.isErrorForTask(this.task);
        },
        isTaskInEndState: function() {
            return this.isEndStateForTask(this.task);
        },
        isTaskBookingCancelled: function() {
            if (this.task.booking) {
                return this.isBookingCancelledForTask(this.task);
            }
            return false;
        },
        hasActions: function () {
            if (this.isTaskInEndState) {
                return false;
            }
            return this.isMarkDoneAction ||
                this.isComposeAction ||
                this.isViewAction ||
                this.isCheckOutAction ||
                this.isCheckInAction ||
                this.isRescheduleAction ||
                this.isIgnoreAction
        },
        isSendSMSAction: function () {
            const type = String(this.task.type)
            return type === 'sms';
        },
        isSendEmailAction: function () {
            const type = String(this.task.type)
            return (type === 'email' || type === 'omni-channel' || type === 'omni-channel-form');
        },
        canResend: function () {
            const state = String(this.task.state)
            return (state === 'notified' || state === 'doing' || state === 'complete') && this.isSendEmailAction
        },
        isMarkDoneAction: function () {
            const type = String(this.task.type)
            return type === 'todo' && !this.isTaskInEndState
        },
        isComposeAction: function () {
            const type = String(this.task.type)
            return type === 'email' && !this.isTaskInEndState
        },
        isViewAction: function () {
            const type = String(this.task.type)
            return type === 'guest-form' || type === 'omni-channel-form'
        },
        isCheckOutAction: function () {
            const type = String(this.task.type)
            return type === 'check-out' && !this.isTaskInEndState
        },
        isCheckInAction: function () {
            const type = String(this.task.type)
            return type === 'check-in' && !this.isTaskInEndState
        },
        isRescheduleAction: function () {
            return (this.isTaskScheduled || this.isTaskPaused || this.isTaskError || this.isTaskCancelled)
        },
        isIgnoreAction: function () {
            return this.isTaskScheduled && !this.isTaskInEndState
        },
        actionDoneText: function () {
            if (!this.hasActions) {
                const state = String(this.task.state)
                switch (state) {
                    case 'complete':
                        return 'Done'
                    case 'notified':
                        return 'Sent'
                }
            }
            return ''
        },
    },
    methods: {
        taskIconForTask: function (task) {
            switch (String(task.type)) {
                case 'check-in':
                    return '<i class="fas fa-door-open" aria-hidden="true"></i>';
                case 'check-out':
                    return '<i class="fas fa-door-closed" aria-hidden="true"></i>';
                case 'guest-form':
                case 'omni-channel-form':
                    return '<i class="fab fa-wpforms" aria-hidden="true"></i>';
                case 'email':
                    return '<i class="fas fa-envelope" aria-hidden="true"></i>';
                case 'sms':
                    return '<i class="fas fa-sms" aria-hidden="true"></i>';
                case 'upsell':
                    return '<i class="fas fa-cart-plus automation-type-icon" aria-hidden="true"></i>';
                case 'webhook':
                    return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 92 81"\n' +
                        'fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" class="task-icon--webhook">\n' +
                        '<path d="M59.165 62.735l1.967 2.483c3.4 3.469 9.202 3.66 12.836.414 3.801-3.374 3.967-9.008.4-12.509-3.5-3.438-9.501-3.756-12.769-.128-1.967 2.197-4 2.483-6.601 2.419l-20.17-.032c.433 9.04-3.134 14.642-10.235 15.979-6.935 1.305-13.303-2.069-15.57-8.244-2.567-7.003.6-12.605 9.735-17.06l-2.067-7.162C6.722 40.963-.712 50.193.054 60.57c.667 9.167 8.402 17.284 17.87 18.748 5.134.796 9.968-.032 14.436-2.451 5.768-3.119 9.101-8.053 10.668-14.132h16.136zm-6.301-36.318c.4-.987.8-1.782 1.1-2.61 1.034-2.992.4-5.698-1.6-8.117-2.434-2.96-6.735-4.043-10.369-2.706-3.668 1.337-6.034 4.807-5.868 8.594.167 3.883 2.867 7.321 7.068 8.021 2.5.414 3.734 1.528 4.867 3.502 3.301 5.825 6.768 11.554 10.202 17.347 8.235-5.22 15.036-5.061 20.104.382a12.41 12.41 0 0 1 .233 16.774c-5.034 5.666-11.802 5.888-19.537 1.114l-6.134 4.902c7.835 7.448 19.003 8.435 27.838 2.642 8.635-5.666 11.602-16.52 7.235-25.687-3.634-7.608-13.736-14.706-27.172-10.727l-7.968-13.432zm-10.702 7.13c-8.701-4.201-11.902-9.74-9.802-16.52 1.867-5.984 8.134-9.867 14.502-8.976 3.2.477 5.968 1.719 8.168 4.075 3.301 3.597 4.034 7.798 3.034 12.477l7.535 1.942c3.201-8.403-.567-18.207-8.768-23.236-8.568-5.252-19.637-4.169-26.905 2.673-3.801 3.565-5.868 7.926-6.368 12.987-.667 7.098 2.4 12.859 7.601 17.793l-8.268 13.178c-.733.064-1.2.064-1.666.128-5.401.732-9.235 5.347-8.335 10.026 1.033 5.315 6.101 8.562 11.269 7.257 5.501-1.369 8.435-6.43 6.368-11.65-.767-1.878-.3-3.087.667-4.551l10.969-17.602z"\n' +
                        'stroke="none"/></svg>\n';
                case 'whatsapp':
                    return '<i class="fas fa-comments" aria-hidden="true"></i>';
                case 'todo':
                default:
                    return '<i class="fas fa-list" aria-hidden="true"></i>';
            }
        },
        stateIconForOverdueTask: function () {
            return '<i class="fas fa-clock task-state task-state--late" aria-hidden="true"></i>';
        },
        stateIconForScheduledTask: function () {
            return '<i class="far fa-clock task-state task-state--scheduled" aria-hidden="true"></i>';
        },
        stateIconForPausedTask: function (task) {
            if (task.booking && (task.booking.state === 'requesting-amendment' || task.booking.state === 'manually-updating')) {
                return '<i class="fas fa-pause task-state task-state--paused-amending" aria-hidden="true"></i>';
            } else if (task.booking && task.booking.communicationState === 'no-guest-contact-details') {
                return '<i class="fas fa-pause task-state task-state--paused-no-contact-details" aria-hidden="true"></i>';
            } else {
                return '<i class="fas fa-pause task-state task-state--paused" aria-hidden="true"></i>';
            }
        },
        stateIconForNotifiedTask: function (task) {
            if (task.type === 'guest-form') {
                return ''
            }
            return '<i class="fas fa-envelope task-state task-state--notified" aria-hidden="true"></i>';
        },
        stateIconForDoingTask: function () {
            return '<i class="fas fa-edit task-state task-state--doing" aria-hidden="true"></i>';
        },
        stateIconForCompleteTask: function () {
            return '<i class="fas fa-check task-state task-state--complete" aria-hidden="true"></i>';
        },
        stateIconForCancelledTask: function () {
            return '<i class="fas fa-times task-state task-state--cancelled" aria-hidden="true"></i>';
        },
        stateIconForErrorTask: function () {
            return '<i class="fas fa-exclamation-triangle task-state task-state--late" aria-hidden="true"></i>';
        },
        stateIconForTask: function (task) {
            if (task.overdue && !this.isEndStateForTask(task)) {
                return this.stateIconForOverdueTask();
            }
            switch (String(task.state)) {
                case "created":
                    return '';
                case "scheduled":
                    return this.stateIconForScheduledTask();
                case "paused":
                    return this.stateIconForPausedTask(task);
                case "notified":
                    return this.stateIconForNotifiedTask(task);
                case "doing":
                    return this.stateIconForDoingTask();
                case "complete":
                    return this.stateIconForCompleteTask();
                case "cancelled":
                    return this.stateIconForCancelledTask();
                case "error":
                    return this.stateIconForErrorTask();
                default:
                    return '';
            }
        },
        tooltipTextForStateForTask: function(task) {
            if (task.overdue && !this.isEndStateForTask(task)) {
                return 'Overdue';
            }
            switch (String(task.state)) {
                case "created":
                    return '';
                case "scheduled":
                    return 'Scheduled';
                case "paused":
                    if (task.booking && task.booking.state === 'requesting-amendment') {
                        return 'Paused - requested amendment';
                    } else if (task.booking && task.booking.communicationState === 'no-guest-contact-details') {
                        return 'Paused - no booker email or mobile';
                    } else {
                        return 'Paused';
                    }
                case "notified":
                    return 'Guest has been notified';
                case "doing":
                    return 'Guest is busy doing this task';
                case "complete":
                    return 'Completed';
                case "cancelled":
                    return 'Cancelled';
                case "error":
                    return 'Error!';
                default:
                    return '';
            }
        },
        taskNameForTask: function(task) {
            switch (String(task.type)) {
                case 'check-in':
                case 'check-out':
                    return dayjs(task.scheduledDate).format("HH:MM");
                case 'guest-form':
                case 'omni-channel-form':
                case 'todo':
                case "email":
                case "sms":
                case "upsell":
                case 'webhook':
                case 'whatsapp':
                    return task.name;
                default:
                    return '';
            }
        },
        isScheduledForTask: function(task) {
            const state = String(task.state)
            return state === 'scheduled'
        },
        isPausedForTask: function(task) {
            const state = String(task.state)
            return state === 'paused'
        },
        isCancelledForTask: function(task) {
            const state = String(task.state)
            return state === 'cancelled'
        },
        isCompletedForTask: function(task) {
            const state = String(task.state)
            return state === 'complete'
        },
        isErrorForTask: function(task) {
            const state = String(task.state)
            return state === 'error'
        },
        isEndStateForTask: function(task) {
            const state = String(task.state)
            return state === "complete" || state === "cancelled" || state === "error"
        },
        isBookingCancelledForTask: function(task) {
            if (this.task.booking) {
                return this.isBookingCancelled(task.booking);
            }
            return false;
        },
        sortByScheduledDate: function(tasks) {
            tasks.sort(this.compareTasksByScheduledDate);
        },
        sortByStateAndScheduledDate: function(tasks) {
            tasks.sort((a, b) => {
                if (a.state !== 'cancelled' && b.state === 'cancelled') {
                    return -1;
                } else if (a.state === 'cancelled' && b.state !== 'cancelled') {
                    return 1;
                } else {
                    return this.compareTasksByScheduledDate(a, b);
                }
            });
        },
        compareTasksByScheduledDate: function(a, b) {
            if (dayjs(a.scheduledDate).isBefore(dayjs(b.scheduledDate))) {
                return -1;
            } else if (dayjs(a.scheduledDate).isAfter(dayjs(b.scheduledDate))) {
                return 1;
            } else {
                return 0;
            }
        }
    }
};